import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledAvaialbleLiveTasks = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 8px;
  background-color: ${Colors.backgroundPaleBlue};

  .ant-spin-nested-loading {
    flex: 1;
    display: flex;
    height: 100%;
  }
  .ant-spin-container {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .title {
    margin-bottom: 15px;
  }

  .list-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
    position: relative;
    overflow-y: auto;
  }
`;
